import * as React from "react";

interface ChevronDownProps {
    className?: string;
    color?: string;
    width?: number;
    height?: number;
}

const ChevronDown: React.FC<ChevronDownProps> = ({
    className = "",
    color = "currentColor",
    width = 16,
    height = 16
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="m6 12 4-4-4-4"
            stroke={color}
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ChevronDown;
